module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Location2_16"],"path":[{"$":{"d":"M8,0A4.89,4.89,0,0,0,3,4.78c0,2.54,4.47,7.61,4.66,7.82L8,13l.31-.35C8.53,12.39,13,7.31,13,4.78A4.89,4.89,0,0,0,8,0ZM8,7.29A2.46,2.46,0,0,1,5.54,4.86a2.49,2.49,0,0,1,5,0A2.46,2.46,0,0,1,8,7.29ZM15,13c0,1.95-3.61,3-7,3s-7-1.05-7-3c0-1.18,1.32-2,3.11-2.51.21.3.43.59.64.87C3,11.76,2,12.45,2,13c0,.83,2.28,2,6,2s6-1.17,6-2c0-.55-1-1.23-2.71-1.64.21-.28.42-.56.64-.86C13.7,11,15,11.83,15,13Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Location2_16.svg
// module id = gFLK
// module chunks = 1